import { Component, OnInit } from '@angular/core';
import { ServiciosService } from '../../services/servicios.service';

@Component({
  selector: 'app-asignar-tiempo-muerto',
  templateUrl: './asignar-tiempo-muerto.component.html',
  styleUrls: ['./asignar-tiempo-muerto.component.scss']
})
export class AsignarTiempoMuertoComponent implements OnInit {

    public tiempomuerto;/* muetra los datos de la tabla tiempomuerto */

  constructor(private servicio:ServiciosService) { }

  ngOnInit() {
      this.servicio.tiempoMuerto().subscribe((data)=>{
          this.tiempomuerto = data;
      })
  }

}
